@if (isCaIcon) {
  <ca-icon [className]="purpose" [name]="_iconLabel"></ca-icon>
}
@if (!isCaIcon) {
  <mat-icon [className]="purpose">{{ _iconLabel }}</mat-icon>
}
